

export default [
  {
    title: 'ข้อมูลสมาชิก (ผู้ซื้อ)',
    icon: 'UserIcon',
    children: [
      {
        title: 'รายการข้อมูล',
        route: 'member-list',
      },
      {
        title: 'ดูข้อมูล',
        route: { name: 'member-view', params: { id: 21 } },
        disabled: true,
      },
      // {
      //   title: 'แก้ไขข้อมูล',
      //   route: { name: 'member-edit', params: { id: 21 } },
      // },
      // {
      //   title: 'เพิ่มข้อมูล',
      //   route: { name: 'member-add' },
      // },
    ],
  },
]
